<template>
  <component
    :is="formComponent"
    :value="value"
     @input="$emit('input', $event)"
  />
</template>

<script>
import CONSTANTS from '@/constants/constants';
import WebsiteLinkForm from './WebsiteLinkForm.vue';
import QRCodeForm from './QRCodeForm.vue';
import BarcodeForm from './BarcodeForm.vue';

export default {
  name: 'CouponCtaForm',

  components: {
    WebsiteLinkForm,
    QRCodeForm,
    BarcodeForm,
  },

  props: {
    value: { type: Object, default: () => {}, required: true }, // coupon object
  },

  computed: {
    ctaType() {
      return this.value.cta || CONSTANTS.couponCtaTypes.redeem.value;
    },

    formComponent() {
      return {
        [CONSTANTS.couponCtaTypes.redeem.value]: null,
        [CONSTANTS.couponCtaTypes.buy.value]: 'WebsiteLinkForm',
        [CONSTANTS.couponCtaTypes.info.value]: 'WebsiteLinkForm',
        [CONSTANTS.couponCtaTypes.qrCode.value]: 'QRCodeForm',
        [CONSTANTS.couponCtaTypes.barcode.value]: 'BarcodeForm',
      }[this.ctaType];
    },
  },
};
</script>
